import { type ReactElement } from 'react';

export const VideoTourIcon = (): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 5H20V19H4V5ZM3 4H21V20H3V4ZM15 12L10 15V9L15 12ZM11 10.7662L13.0563 12L11 13.2338V10.7662Z"
        fill="currentColor"
      />
    </svg>
  );
};
